package com.crowpay.views.components.project

import com.crowpay.views.components.nav.AppDimensions
import com.crowpay.utils.Action
import com.crowpay.utils.existsDefaultFalse
import com.crowpay.views.screens.auth.loginBanner
import com.crowpay.views.screens.common.ProjectView
import com.crowpay.views.theming.AuthDialogSemantic
import com.crowpay.views.theming.appTheme
import com.crowpay.views.theming.body
import com.crowpay.views.theming.bodyBold
import com.crowpay.views.theming.greySeparator
import com.crowpay.views.theming.primaryButton
import com.crowpay.views.theming.secondaryButton
import com.crowpay.views.theming.specCenteredText
import com.crowpay.views.theming.subTitle
import com.crowpay.views.theming.title
import com.lightningkite.kiteui.models.ThemeDerivation
import com.lightningkite.kiteui.models.rem
import com.lightningkite.kiteui.reactive.invoke
import com.lightningkite.kiteui.views.ViewWriter
import com.lightningkite.kiteui.views.centered
import com.lightningkite.kiteui.views.direct.button
import com.lightningkite.kiteui.views.direct.col
import com.lightningkite.kiteui.views.direct.row
import com.lightningkite.kiteui.views.direct.rowCollapsingToColumn
import com.lightningkite.kiteui.views.direct.sizeConstraints
import com.lightningkite.kiteui.views.direct.space
import com.lightningkite.kiteui.views.direct.stack
import com.lightningkite.kiteui.views.expanding


fun ProjectView.inviteView(writer: ViewWriter) = with(writer) {

    centered - rowCollapsingToColumn(80.rem) {
        col {
            centered - loginBanner()
            centered - AuthDialogSemantic.onNext - stack {
                spacing = AppDimensions.sectionIndent
                sizeConstraints(width = 30.rem) - col {
                    themeChoice = ThemeDerivation(appTheme)
                    col {
                        centered - title("You're Invited!")
                        centered - subTitle {
                            ::content {
                                "Invited by: ${contractor().name}"
                            }
                        }
                    }
                    greySeparator()
                    col {
                        spacing = 0.rem
                        title("Project Preview")
                        bodyBold {
                            ::content {
                                project().name
                            }
                        }
                        body {
                            ::content {
                                project().description
                            }
                        }
                        space()
                        bodyBold("Project Address")
                        body {
                            ::content {
                                project().address.let { "${it.line1}, ${it.city}, ${it.state}, ${it.zipcode}" }
                            }
                        }
                        space()
                        bodyBold("Client")
                        body {
                            ::content {
                                client().name
                            }
                        }
                    }
                }
            }
        }
        space(2.0)
        centered - AuthDialogSemantic.onNext - sizeConstraints(width = 25.rem) - stack {
            spacing = AppDimensions.sectionIndent
            col {
                themeChoice = ThemeDerivation(appTheme)
                bodyBold("Welcome to CrowPay, we're looking forward to protecting your project.")
                space()
                col {
                    body {
                        ::content {
                            "${contractor().name} wants to ensure performance on your project. Using CrowPay allows you to deposit funds and only release payment as performance milestones are perfect"
                        }
                    }
                    body("Register now or log in to review details and award the project")
                }
                space()
                row {
                    expanding - space()
                    centered - row {
                        existsDefaultFalse { anonymous() }
                        spacing = AppDimensions.buttonSpacing
                        primaryButton - button {
                            specCenteredText("Register")

                            action = Action("Register") { onRegister() }
                        }
                        secondaryButton - button {
                            specCenteredText("Log In")

                            action = Action("Log In") { onLogin() }
                        }
                    }
                    expanding - space()
                }
            }
        }
    }
}